exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login[data-v-4d46cdff]{margin-top:32px;text-align:center}#login .logo[data-v-4d46cdff]{width:64px;height:64px}", ""]);

// exports
